export const ACTIVE_ROUTES = [
  {
    id: 'RT-101',
    routeName: 'Abu Dhabi Refineries → Jebel Ali Port',
    tankerId: 'AD-115',
    salikGates: [
      { name: 'Al Barsha', aed: 8 },
      { name: 'Al Safa', aed: 8 },
    ],
    totalSalikAed: 16,
    fuelLiters: 185,
    fuelCostAed: 518,
    aiOptimized: true,
  },
  {
    id: 'RT-102',
    routeName: 'Ruwais Terminal → Dubai Industrial City',
    tankerId: 'TX-402',
    salikGates: [
      { name: 'Mamzar', aed: 8 },
      { name: 'Al Barsha', aed: 8 },
      { name: 'Business Bay', aed: 8 },
    ],
    totalSalikAed: 24,
    fuelLiters: 220,
    fuelCostAed: 616,
    aiOptimized: true,
  },
  {
    id: 'RT-103',
    routeName: 'Jebel Ali Port → Sharjah Industrial Zone',
    tankerId: 'DX-881',
    salikGates: [
      { name: 'Al Safa', aed: 8 },
      { name: 'Al Mamzar', aed: 8 },
    ],
    totalSalikAed: 16,
    fuelLiters: 95,
    fuelCostAed: 266,
    aiOptimized: false,
  },
  {
    id: 'RT-104',
    routeName: 'Fujairah Port → Abu Dhabi Mussafah',
    tankerId: 'SH-203',
    salikGates: [{ name: 'Sheikh Zayed Rd', aed: 8 }],
    totalSalikAed: 8,
    fuelLiters: 310,
    fuelCostAed: 868,
    aiOptimized: true,
  },
];

export const CUSTOMS_SHIPMENTS = [
  {
    id: 'SHP-2401',
    client: 'ADNOC',
    customsOffice: 'Dubai Customs',
    boeNumber: 'BOE-DXB-2026-88421',
    status: 'cleared',
    hazmatPermitExpiry: '2026-09-15',
    hazmatDaysRemaining: 95,
  },
  {
    id: 'SHP-2402',
    client: 'Emirates Gas',
    customsOffice: 'Jebel Ali Free Zone',
    boeNumber: 'BOE-JAFZA-2026-11203',
    status: 'pending_documents',
    hazmatPermitExpiry: '2026-06-18',
    hazmatDaysRemaining: 6,
  },
  {
    id: 'SHP-2403',
    client: 'ADNOC',
    customsOffice: 'Abu Dhabi Customs',
    boeNumber: 'BOE-AUH-2026-55678',
    status: 'inspected',
    hazmatPermitExpiry: '2026-07-30',
    hazmatDaysRemaining: 48,
  },
  {
    id: 'SHP-2404',
    client: 'Emirates Gas',
    customsOffice: 'Sharjah Customs',
    boeNumber: 'BOE-SHJ-2026-33901',
    status: 'pending_documents',
    hazmatPermitExpiry: '2026-06-14',
    hazmatDaysRemaining: 2,
  },
  {
    id: 'SHP-2405',
    client: 'ADNOC',
    customsOffice: 'Jebel Ali Port Customs',
    boeNumber: 'BOE-JAP-2026-77234',
    status: 'cleared',
    hazmatPermitExpiry: '2026-11-01',
    hazmatDaysRemaining: 142,
  },
];

export const BILLING_ACCOUNTS = [
  {
    id: 'ACC-001',
    companyName: 'Abu Dhabi National Oil Company',
    shortCode: 'ADNOC',
    plan: 'Enterprise Monthly',
    fleetSize: 47,
    nextInvoiceDate: '2026-07-01',
    monthlyAed: 28500,
    contractEnd: '2026-12-31',
  },
  {
    id: 'ACC-002',
    companyName: 'Emirates Gas LLC',
    shortCode: 'EMGAS',
    plan: 'Per-Truck License',
    fleetSize: 23,
    nextInvoiceDate: '2026-06-20',
    monthlyAed: 9200,
    contractEnd: '2026-08-28',
  },
  {
    id: 'ACC-003',
    companyName: 'Gulf Petrochemical Industries',
    shortCode: 'GPIC',
    plan: 'Enterprise Monthly',
    fleetSize: 12,
    nextInvoiceDate: '2026-07-15',
    monthlyAed: 14800,
    contractEnd: '2027-03-31',
  },
  {
    id: 'ACC-004',
    companyName: 'Borouge Trading',
    shortCode: 'BOROUGE',
    plan: 'Per-Truck License',
    fleetSize: 8,
    nextInvoiceDate: '2026-06-25',
    monthlyAed: 3200,
    contractEnd: '2026-06-30',
  },
];

export const CUSTOMS_STATUS = {
  cleared: {
    label: 'Cleared',
    className: 'bg-emerald-500/15 text-emerald-700 ring-emerald-500/30',
  },
  pending_documents: {
    label: 'Pending Documents',
    className: 'bg-amber-500/15 text-amber-700 ring-amber-500/30',
  },
  inspected: {
    label: 'Inspected',
    className: 'bg-logi-accent/100/15 text-blue-700 ring-blue-500/30',
  },
};
